export default __webpack_public_path__ + "static/media/About_Landing-09.754e79fe.png";